import { fetchRetailRecommendations } from "./g-utils";

class RecommendationCarousel extends HTMLElement {
  constructor() {
    super();
  }

  async connectedCallback() {
    const ajaxRecommendationSection = document.querySelector(
      "[data-recommendation]"
    );
    if (!ajaxRecommendationSection) {
      return;
    }
    const ajaxRecommendationSectionId =
      ajaxRecommendationSection.dataset.sectionId;
    const recommendationProducts = await this.getRecommendationProducts();
    const shopifyIds = recommendationProducts.result
      .map((product) => product.id)
      .join(",");
    const url = `/search/?sections=${ajaxRecommendationSectionId}&product_ids=${shopifyIds}`;
    await fetch(url).then((r) => {
      r.json().then((res) => {
        var keys = Object.keys(res);
        if (keys.length > 0) {
          const recommendationTemplateText = res[keys[0]];
          const parser = new DOMParser();
          const recommendationTemplateParse = parser.parseFromString(
            recommendationTemplateText,
            "text/html"
          );
          const recommendationTemplate =
            recommendationTemplateParse.querySelector(
              "[data-recommendation]"
            ).innerHTML;
          this.innerHTML = recommendationTemplate;
        }
      });
    });
  }

  disconnectedCallback() {}

  templateRecommendationProducts(
    recommendationProducts,
    templateRecommendationCard
  ) {
    return recommendationProducts.result
      .map((product) => {
       
        return templateRecommendationCard
          .replaceAll("[imgSrc]", product.image ? product.image : "")
          .replaceAll("[title]", product.title)
          .replaceAll("[author]", product.author)
          .replaceAll("[productUrl]", product.uri);

      })
      .join("");
  }

  async getRecommendationProducts() {
    const lastOrderProductIds = this.dataset.lastOrderIds
      .split(",")
      .map((id) => {
        return {
          primaryProductId: id,
        };
      });

      const response = await fetchRetailRecommendations({
        type: "fbt",
        products: lastOrderProductIds,
        pageSize: undefined
      })
  

      return response;
  
  }
}

customElements.define("recommendation-carousel", RecommendationCarousel);
